import React, { Component} from 'react';
import * as actions from '../actions/index'

export default class Support extends Component {

  componentWillMount() {
    this.props.dispatch(actions.setTopbarButtons([]))
  }

  render() {
    return (
      <div>
        <h3>Support</h3>
        <p>We are so happy to help! Please contact us
          at <a href="mailto:support@assisthub.io">support@assisthub.io</a> and
          we will be back promptly!
        </p>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Support.js